import Home from "@pathwright/features/src/modules/unified-home/Home"

const Homescreen = () => {
  return <Home key="Home" />
}

Homescreen.displayName = "Homescreen"

export default Homescreen
